import kommendBackground from '@/assets/feed/kommend-background.webp'

export interface AmbientPageBackdropProps {
  /** 'imageOnly' drops the dim + center-strip gradient layers, leaving just the photo. */
  variant?: 'default' | 'imageOnly'
}

export function AmbientPageBackdrop({ variant = 'default' }: AmbientPageBackdropProps = {}) {
  if (variant === 'imageOnly') {
    return (
      <div className="pointer-events-none fixed inset-0 z-0 hidden md:block" aria-hidden="true">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-[0.38]"
          style={{ backgroundImage: `url(${kommendBackground})` }}
        />
      </div>
    )
  }

  return (
    <div className="pointer-events-none fixed inset-0 z-0 hidden md:block" aria-hidden="true">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-[0.38]"
        style={{ backgroundImage: `url(${kommendBackground})` }}
      />
      <div className="absolute inset-0 bg-[var(--y-bg)] opacity-45" />
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, transparent 10%, var(--y-bg-secondary) 34%, var(--y-bg-secondary) 66%, transparent 90%, transparent 100%)',
        }}
      />
      <div className="absolute inset-y-0 left-1/2 w-[min(100vw,48rem)] -translate-x-1/2 bg-[var(--y-bg-secondary)]" />
    </div>
  )
}
